import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goacabservice() {



    const cardData = {


keyword: "Goa Cab Service",

headingDescription: "Belgaum Taxi Service offers reliable Goa cab services for local sightseeing, airport transfers, hotel pickups, beach tours, corporate travel, family vacations, railway station transfers, and outstation journeys. Whether you need a cab within North Goa, South Goa, or a taxi for intercity travel, we provide safe, comfortable, and affordable transportation with experienced chauffeurs. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for couples, families, groups, and corporate travelers. We offer one-way taxi services, round-trip cabs, full-day sightseeing packages, airport transfers, and customized travel plans to suit your schedule. With transparent pricing, doorstep pickup, well-maintained vehicles, easy online booking, flexible travel timings, and 24/7 customer support, Belgaum Taxi Service is your trusted partner for comfortable cab services across Goa and nearby destinations.",

topPlaces: [
  {
    title: "Calangute",
    description: "Calangute is Goa's most popular beach destination, known for its lively atmosphere, beach resorts, shopping streets, restaurants, and exciting water sports activities."
  },
  {
    title: "Vagator",
    description: "Vagator is famous for its dramatic cliffs, beautiful beaches, vibrant nightlife, beach cafés, and stunning sunset views overlooking the Arabian Sea."
  },
  {
    title: "Old Goa",
    description: "Old Goa is a UNESCO World Heritage destination known for its magnificent churches, Portuguese architecture, museums, and rich historical significance."
  },
  {
    title: "Dona Paula",
    description: "Dona Paula is a scenic waterfront destination offering panoramic sea views, water sports, and one of Goa's most photographed viewpoints."
  },
  {
    title: "Miramar Beach",
    description: "Miramar Beach is a peaceful stretch of coastline near Panaji, ideal for morning walks, family outings, and relaxing sunset views."
  },
  {
    title: "Colva",
    description: "Colva is a popular South Goa beach destination featuring white sandy beaches, beach shacks, seafood restaurants, and a relaxing holiday atmosphere."
  },
  {
    title: "Palolem",
    description: "Palolem Beach is known for its crescent-shaped shoreline, calm waters, kayaking, beach cottages, and peaceful surroundings, making it ideal for family vacations."
  },
  {
    title: "Dudhsagar Waterfalls",
    description: "Dudhsagar Waterfalls is one of India's tallest waterfalls, surrounded by lush forests and scenic landscapes, attracting thousands of nature lovers every year."
  },
  {
    title: "Aguada Fort",
    description: "Fort Aguada is a historic Portuguese fort overlooking the Arabian Sea, offering breathtaking coastal views and serving as one of Goa's most visited landmarks."
  },
  {
    title: "Mopa International Airport",
    description: "Manohar International Airport (Mopa) is North Goa's modern airport, providing convenient connectivity for domestic and international travelers requiring reliable cab services."
  }
],




"services": [
  {
    "name": "Goa Cab Service",
    "description": "Book Goa Cab Service for reliable local and outstation travel with professional chauffeurs, clean AC Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles. Enjoy fixed fares, online booking, airport transfers, sightseeing tours, family trips, business travel, hotel pickup, and 24×7 customer support."
  },
  {
    "name": "Taxi Service in Goa",
    "description": "Choose Taxi Service in Goa for comfortable transportation with experienced drivers, transparent pricing, sanitized vehicles, flexible pickup timing, and reliable travel across Goa."
  },
  {
    "name": "Goa Taxi",
    "description": "Book Goa Taxi for airport transfers, hotel pickup, sightseeing, beach tours, corporate travel, and outstation journeys with affordable fares and professional chauffeurs."
  },
  {
    "name": "Cabs in Goa",
    "description": "Hire Cabs in Goa with Sedan, Ertiga, Innova Crysta, SUVs, and luxury vehicles for local sightseeing, airport transfers, family vacations, and business travel."
  },
  {
    "name": "Goa Taxi Booking",
    "description": "Complete Goa Taxi Booking online with instant confirmation, secure reservations, multiple vehicle choices, and round-the-clock booking assistance."
  },
  {
    "name": "Goa Cabs",
    "description": "Reserve Goa Cabs for comfortable city rides, beach transfers, airport pickup, hotel transportation, and outstation travel with experienced drivers."
  },
  {
    "name": "Cheapest Cab Service in Goa",
    "description": "Book Cheapest Cab Service in Goa with affordable fares, clean AC vehicles, fixed pricing, and dependable transportation without hidden charges."
  },
  {
    "name": "Goa Cab Booking",
    "description": "Choose Goa Cab Booking for quick online reservations, transparent fares, professional chauffeurs, and comfortable travel throughout Goa."
  },
  {
    "name": "Goa Airport Taxi",
    "description": "Book Goa Airport Taxi for timely airport pickup and drop with luggage assistance, experienced drivers, fixed fares, and comfortable transportation."
  },
  {
    "name": "Cab Booking in Goa",
    "description": "Reserve Cab Booking in Goa with instant confirmation, multiple vehicle options, secure payment, and reliable chauffeur-driven travel."
  },
  {
    "name": "Online Taxi Service in Goa",
    "description": "Enjoy Online Taxi Service in Goa with easy booking, affordable pricing, premium vehicles, and professional drivers available 24×7."
  },
  {
    "name": "Airport Taxi Goa",
    "description": "Choose Airport Taxi Goa for reliable airport transfers with punctual pickup, clean AC vehicles, and hassle-free travel."
  },
  {
    "name": "Goa Airport Taxi Service",
    "description": "Book Goa Airport Taxi Service with fixed pricing, professional chauffeurs, premium vehicles, and convenient airport transportation."
  },
  {
    "name": "Best Cab Service in Goa",
    "description": "Experience the Best Cab Service in Goa with premium vehicles, courteous chauffeurs, transparent pricing, and excellent customer support."
  },
  {
    "name": "Goa Taxi Rental",
    "description": "Hire Goa Taxi Rental for local travel, sightseeing, airport transfers, corporate trips, and outstation journeys with flexible rental plans."
  },
  {
    "name": "Taxi Service in South Goa",
    "description": "Book Taxi Service in South Goa for convenient transportation to beaches, resorts, tourist attractions, hotels, and airport transfers."
  },
  {
    "name": "Taxi in Goa Airport",
    "description": "Reserve Taxi in Goa Airport with direct pickup, fixed fares, experienced drivers, and comfortable travel to any destination."
  },
  {
    "name": "Online Cab Booking Goa",
    "description": "Complete Online Cab Booking Goa with secure reservations, instant confirmation, and multiple cab options for every travel need."
  },
  {
    "name": "Cheapest Taxi Service in Goa",
    "description": "Find Cheapest Taxi Service in Goa with economical pricing, professional drivers, clean AC vehicles, and dependable transportation."
  },
  {
    "name": "Goa Airport Cabs",
    "description": "Book Goa Airport Cabs for comfortable airport transfers with premium vehicles, timely pickup, luggage support, and reliable service."
  },
  {
    "name": "Taxi Service in North Goa",
    "description": "Choose Taxi Service in North Goa for sightseeing, beach tours, hotel transfers, nightlife travel, and airport pickup with experienced chauffeurs."
  },
  {
    "name": "Calangute Taxi Service",
    "description": "Book Calangute Taxi Service for local sightseeing, beach transfers, hotel pickup, airport travel, and comfortable outstation journeys."
  },
  {
    "name": "Online Taxi Booking in Goa",
    "description": "Reserve Online Taxi Booking in Goa with quick confirmation, fixed fares, secure payment, and reliable chauffeur-driven vehicles."
  },
  {
    "name": "Agonda Taxi Service",
    "description": "Hire Agonda Taxi Service for beach travel, sightseeing, airport transfers, family vacations, and comfortable local transportation."
  },
  {
    "name": "Baga Taxi Service",
    "description": "Book Baga Taxi Service for beach trips, nightlife travel, airport pickup, hotel transfers, and outstation journeys with professional drivers."
  },
  {
    "name": "Goa to Belgaum Cab",
    "description": "Reserve Goa to Belgaum Cab with one way and round trip options, AC vehicles, fixed fares, experienced chauffeurs, and comfortable highway travel."
  },
  {
    "name": "Goa to Pune Cab",
    "description": "Book Goa to Pune Cab with Sedan, Ertiga, Innova Crysta, SUVs, transparent pricing, and reliable intercity transportation."
  },
  {
    "name": "Goa to Mumbai Cab",
    "description": "Choose Goa to Mumbai Cab for comfortable long-distance travel with premium vehicles, fixed fares, and professional drivers."
  },
  {
    "name": "Goa to Bangalore Cab",
    "description": "Reserve Goa to Bangalore Cab for safe intercity travel with spacious vehicles, affordable pricing, and experienced chauffeurs."
  },
  {
    "name": "Goa to Hyderabad Cab",
    "description": "Book Goa to Hyderabad Cab for comfortable outstation journeys with AC vehicles, transparent pricing, and reliable customer support."
  },
  {
    "name": "Goa to Kolhapur Cab",
    "description": "Hire Goa to Kolhapur Cab with fixed fares, clean vehicles, experienced drivers, and smooth highway transportation."
  },
  {
    "name": "Goa to Hubli Cab",
    "description": "Choose Goa to Hubli Cab for one way and round trip travel with premium vehicles, punctual pickup, and affordable pricing."
  },
  {
    "name": "Goa to Gokarna Cab",
    "description": "Book Goa to Gokarna Cab for beach vacations, sightseeing, family trips, and comfortable chauffeur-driven travel."
  },
  {
    "name": "Goa to Mahabaleshwar Cab",
    "description": "Reserve Goa to Mahabaleshwar Cab with spacious vehicles, fixed fares, experienced chauffeurs, and convenient long-distance travel."
  },
  {
    "name": "Goa Outstation Taxi Service",
    "description": "Choose Goa Outstation Taxi Service for intercity travel with Sedan, Ertiga, Innova Crysta, SUVs, transparent pricing, and reliable service."
  },
  {
    "name": "Best Cab Company in Goa",
    "description": "Travel with the Best Cab Company in Goa offering premium vehicles, professional drivers, affordable fares, and dependable transportation."
  },
  {
    "name": "Top Taxi Service in Goa",
    "description": "Book Top Taxi Service in Goa with quality vehicles, experienced chauffeurs, fixed pricing, and excellent customer satisfaction."
  },
  {
    "name": "Affordable Cab Service Goa",
    "description": "Find Affordable Cab Service Goa with budget-friendly fares, clean AC vehicles, and reliable travel for local and outstation journeys."
  },
  {
    "name": "Safe Taxi Service Goa",
    "description": "Choose Safe Taxi Service Goa with verified chauffeurs, sanitized vehicles, GPS-enabled rides, and secure transportation."
  },
  {
    "name": "Premium Cab Service Goa",
    "description": "Reserve Premium Cab Service Goa with luxury vehicles, courteous chauffeurs, airport transfers, business travel, and family vacations."
  },
  {
    "name": "Family Cab Service Goa",
    "description": "Book Family Cab Service Goa with spacious vehicles, child-friendly travel, luggage support, and comfortable sightseeing trips."
  },
  {
    "name": "Business Travel Cab Goa",
    "description": "Choose Business Travel Cab Goa for corporate meetings, airport transfers, executive travel, and professional chauffeur service."
  },
  {
    "name": "Airport Pickup Cab Goa",
    "description": "Reserve Airport Pickup Cab Goa with on-time pickup, flight tracking, luggage assistance, and comfortable airport transportation."
  },
  {
    "name": "Outstation Car Rental Goa",
    "description": "Hire Outstation Car Rental Goa with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUVs, and flexible travel packages."
  },
  {
    "name": "Taxi Booking App Goa",
    "description": "Book through Taxi Booking App Goa for instant reservations, secure payment, multiple vehicle choices, real-time booking, and reliable customer support."
  }
],

"tableData": [
  ["Goa Cab Service", "Taxi Service in Goa"],
  ["Goa Taxi", "Cabs in Goa"],
  ["Goa Taxi Booking", "Goa Cabs"],
  ["Cheapest Cab Service in Goa", "Goa Cab Booking"],
  ["Goa Airport Taxi", "Cab Booking in Goa"],
  ["Online Taxi Service in Goa", "Airport Taxi Goa"],
  ["Goa Airport Taxi Service", "Best Cab Service in Goa"],
  ["Goa Taxi Rental", "Taxi Service in South Goa"],
  ["Taxi in Goa Airport", "Online Cab Booking Goa"],
  ["Cheapest Taxi Service in Goa", "Goa Airport Cabs"],
  ["Taxi Service in North Goa", "Calangute Taxi Service"],
  ["Online Taxi Booking in Goa", "Agonda Taxi Service"],
  ["Baga Taxi Service", "Goa to Belgaum Cab"],
  ["Goa to Pune Cab", "Goa to Mumbai Cab"],
  ["Goa to Bangalore Cab", "Goa to Hyderabad Cab"],
  ["Goa to Kolhapur Cab", "Goa to Hubli Cab"],
  ["Goa to Gokarna Cab", "Goa to Mahabaleshwar Cab"],
  ["Goa Outstation Taxi Service", "Best Cab Company in Goa"],
  ["Top Taxi Service in Goa", "Affordable Cab Service Goa"],
  ["Safe Taxi Service Goa", "Premium Cab Service Goa"],
  ["Family Cab Service Goa", "Business Travel Cab Goa"],
  ["Airport Pickup Cab Goa", "Outstation Car Rental Goa"],
  ["Taxi Booking App Goa", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Goa Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service provides dependable Goa cab services with experienced drivers, clean vehicles, and comfortable transportation for local and outstation travel."
  },
  {
    WhyChooseheading: "Pickup Anywhere in Goa",
    WhyChoosedescription: "Enjoy convenient cab pickup from North Goa, South Goa, Dabolim Airport, Mopa Airport, railway stations, hotels, resorts, beaches, and all major locations."
  },
  {
    WhyChooseheading: "Wide Range of Well-Maintained Vehicles",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles for solo travelers, families, and groups."
  },
  {
    WhyChooseheading: "Professional & Friendly Chauffeurs",
    WhyChoosedescription: "Our experienced drivers ensure safe driving, punctual service, and a pleasant travel experience throughout your journey in Goa."
  },
  {
    WhyChooseheading: "Local Sightseeing & Outstation Trips",
    WhyChoosedescription: "Book cabs for Goa sightseeing, airport transfers, business travel, beach tours, or outstation journeys to Belgaum, Gokarna, Hubli, Bangalore, and nearby destinations."
  },
  {
    WhyChooseheading: "Affordable Taxi Fare",
    WhyChoosedescription: "Travel with transparent pricing, competitive taxi rates, and no hidden charges for local rides, airport transfers, and outstation travel."
  },
  {
    WhyChooseheading: "Perfect for Holidays & Business Travel",
    WhyChoosedescription: "Our Goa cab services are ideal for family vacations, honeymoon trips, corporate travel, hotel transfers, sightseeing, and weekend getaways."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Reserve your Goa cab anytime with instant confirmation and dedicated customer support for a hassle-free travel experience."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Goa Cab Service?",
    answer: "Yes, Belgaum Taxi Service offers local Goa cab services, airport transfers, sightseeing taxis, and outstation cab bookings."
  },
  {
    question: "Can I book a cab anywhere in Goa?",
    answer: "Yes, cab pickup is available from North Goa, South Goa, hotels, beaches, railway stations, airports, and other major locations."
  },
  {
    question: "Which vehicles are available for Goa cab booking?",
    answer: "Our fleet includes Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles for every travel requirement."
  },
  {
    question: "Do you provide Goa Airport pickup and drop services?",
    answer: "Yes, we offer reliable airport transfers from Dabolim Airport and Mopa Airport to any destination in Goa or nearby cities."
  },
  {
    question: "Can I hire a cab for Goa sightseeing?",
    answer: "Yes, customized sightseeing packages are available for North Goa, South Goa, beaches, forts, temples, churches, and other tourist attractions."
  },
  {
    question: "Is Goa Cab Service available 24/7?",
    answer: "Yes, our taxi services operate 24 hours a day for airport transfers, sightseeing, local travel, and outstation journeys."
  },
  {
    question: "Can I book a one-way or round-trip taxi?",
    answer: "Yes, both one-way and round-trip cab services are available according to your travel requirements."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Do you provide outstation cabs from Goa?",
    answer: "Yes, we provide outstation taxi services from Goa to Belgaum, Hubli, Bangalore, Pune, Mumbai, Gokarna, and many other destinations."
  },
  {
    question: "How can I book a Goa Cab Service?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Fernandes",
    feedback: "Our Goa sightseeing trip was well-planned and comfortable. The driver was courteous, the vehicle was spotless, and we visited every destination without any hassle.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meera Joshi",
    feedback: "The cab arrived exactly on time, the journey was relaxing, and the overall service was excellent. We will definitely choose Belgaum Taxi Service again for our Goa travels.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa Cab Service",
  "image": "https://www.belgaumtaxiservice.com/assets/images/goa-cab-service.webp",
  "description":
    "Book Goa Cab Service with Belgaum Taxi Service for safe, comfortable, and affordable taxi services in Goa. We provide local cabs, airport taxis, sightseeing taxis, outstation cabs, and online taxi booking services across Goa with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/goa-cab-service"
  }
};





    return (
        <div>


<Helmet>
  <title>Goa Cab Service | Airport Taxi & Cab Booking | +91 8722158435</title>

  <meta
    name="description"
    content="Book Goa Cab Service for reliable local, airport, and sightseeing taxi services in Goa. Get affordable Goa taxi booking with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers and travel across Goa."
  />

  <meta
    name="keywords"
    content="Goa Cab Service, Taxi service in goa, Goa taxi, cabs in goa, goa taxi booking, goa cabs, cheapest cab service in goa, goa cab booking, goa airport taxi, cab booking in goa, Online taxi service in goa, Airport taxi goa, Goa airport taxi service, Best cab service in goa, Goa Taxi Booking, Goa Airport Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Goacabservice;